export const MAX_INPUT = 1_000_000_000_000;
export class DomainError extends Error {
    code;
    field;
    constructor(code, message, field) {
        super(message);
        this.code = code;
        this.field = field;
        this.name = 'DomainError';
    }
}
export function assertNumber(value, label, options = {}) {
    if (!Number.isFinite(value))
        throw new DomainError('NOT_FINITE', `${label} muss eine endliche Zahl sein.`, label);
    const min = options.min ?? 0;
    const max = options.max ?? MAX_INPUT;
    if (value < min || value > max || (options.allowZero === false && value === 0)) {
        throw new DomainError('OUT_OF_RANGE', `${label} liegt außerhalb des erlaubten Bereichs.`, label);
    }
    return value;
}
export function assertRate(value, label) {
    return assertNumber(value, label, { min: 0, max: 1 });
}
export function safeMultiply(a, b, label) {
    const value = a * b;
    if (!Number.isFinite(value) || Math.abs(value) > Number.MAX_SAFE_INTEGER) {
        throw new DomainError('OVERFLOW', `${label} ist zu groß für eine sichere Berechnung.`, label);
    }
    return value;
}
export function roundValue(value, mode = 'nearest', digits = 0) {
    if (mode === 'none')
        return value;
    const factor = 10 ** digits;
    const scaled = value * factor;
    const rounded = mode === 'floor' ? Math.floor(scaled) : mode === 'ceil' ? Math.ceil(scaled) : Math.round(scaled);
    return rounded / factor;
}
export function ratioPercent(numerator, denominator) {
    return denominator === 0 ? null : (numerator / denominator) * 100;
}
export function presentPrice(price) {
    return price == null || !Number.isFinite(price) || price <= 0 ? null : price;
}
//# sourceMappingURL=math.js.map